import './App.css';
import SocialMediaIcons from './components/socials/SocialMediaIcons';
import background from './assets/images/adastra.jpeg';
import cover from './assets/images/album-cover-adastra.jpeg';

function App() {
  return (
    <div className="home" style={{ backgroundImage: `url(${background})` }}>
      <SocialMediaIcons />
      <a
        className="out-now"
        href="https://open.spotify.com/album/6Q4fzGvDe5bE9UfVeV5lYX"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="ad astra EP – hallgasd meg Spotify-on"
        style={{ backgroundImage: `url(${cover})` }}
      >
        <span className="out-now-label">OUT NOW</span>
      </a>
    </div>
  );
}

export default App;
